export enum ReportingPageSection {
  NavMenu = 'nav-menu',
  SelfSignupForm = 'self-signup-submit',
  PostAJob = 'post-a-job',
  SaveAndSubscribe = 'save-and-subscribe',
}
